const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "https://api.unity-consult.ch").replace(/\/$/, "");

const idempotencyKey = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = new Uint8Array(24);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
};

export async function getPublicResource(path) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "GET",
    headers: { "Accept-Language": "it-CH" },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.detail || body.title || "Servizio non disponibile");
    error.status = response.status;
    error.problem = body;
    throw error;
  }
  return body;
}

export async function submitPublicForm(path, payload) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": payload.locale || "it-CH",
      "Idempotency-Key": idempotencyKey(),
    },
    body: JSON.stringify(payload),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.detail || body.title || "Invio non riuscito");
    error.status = response.status;
    error.problem = body;
    throw error;
  }
  return body;
}

async function uploadPublicFile(path, file) {
  const session = await submitPublicForm(
    path,
    { file_name: file.name, expected_mime: file.type, size_bytes: file.size },
  );
  if (!session.upload_url || !session.id) throw new Error("Sessione di caricamento non disponibile");
  const upload = await fetch(session.upload_url, {
    method: "PUT",
    headers: session.required_headers || { "Content-Type": file.type },
    body: file,
  });
  if (!upload.ok) throw new Error(`Caricamento di ${file.name} non riuscito`);
  return session;
}

export function uploadPublicClaimFile(publicToken, file) {
  return uploadPublicFile(`/public/v1/claim-submissions/${encodeURIComponent(publicToken)}/uploads`, file);
}

export function uploadPublicContactFile(publicToken, file) {
  return uploadPublicFile(`/public/v1/contact-requests/${encodeURIComponent(publicToken)}/uploads`, file);
}

export function completePublicContactRequest(publicToken) {
  return submitPublicForm(`/public/v1/contact-requests/${encodeURIComponent(publicToken)}/complete`, {});
}

export function completePublicClaimSubmission(publicToken) {
  return submitPublicForm(`/public/v1/claim-submissions/${encodeURIComponent(publicToken)}/complete`, {});
}
